import senxDiscoveryWidgetsGlobalScript from '/home/kyrill/Documents/entreprise/kwh50-discovery-highcharts/node_modules/@senx/discovery-widgets/dist/collection/discovery.js';
import discoveryHighchartsGlobalScript from '/home/kyrill/Documents/entreprise/kwh50-discovery-highcharts/src/plugin.ts';
export const globalScripts = () => {
  return Promise.all([
    discoveryHighchartsGlobalScript(),
    senxDiscoveryWidgetsGlobalScript(),
  ]);
};
